import { render, staticRenderFns } from "./BrandFilterMobile.vue?vue&type=template&id=0af96740&scoped=true&"
import script from "./BrandFilterMobile.vue?vue&type=script&lang=js&"
export * from "./BrandFilterMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af96740",
  null
  
)

export default component.exports